<template>
  <div class="eventUsersComp">

    <div class="div_filter">
      <label class="label_title label_filter" for="">Пользователи</label>
      <multiselect-custom-comp
          ref="users"
          :options="usersCom"
          :values="[]"
          :name="'phone'"
          :disabled="setAll"
      />
    </div>

    <div class="div_filter">
      <label class="label_title label_filter" for="">Группы</label>
      <multiselect-custom-comp
          ref="groups"
          :options="groupsCom"
          :values="[]"
          :name="'name'"
          :disabled="setAll"
      />
    </div>

    <div>
      <div class="div_check">
        <input type="checkbox" :id="`checkbox_isActive`" v-model="setAll">
        <label :for="`checkbox_isActive`" class="check_title">Все пользователи</label>
      </div>
    </div>

    <div class="div_btns">
      <button-comp :classBtn="'btn_orange_min'" :textBtn="'Сохранить'" :clickBtn="save"/>
      <button-comp :classBtn="'btn_orange_min'" :textBtn="'Удалить'" :clickBtn="close"/>
    </div>

    <p class="p_err_main">{{ errMain }}</p>

  </div>
</template>

<script>
import httpService from '../http'
import api from '../api'

export default {
  name: 'eventUsersComp',
  props: {},
  data: function () {
    return {
      required: null,
      moduleName: 'events',
      maxInfo: 250,
      image: null,
      // imgSrc: null

      setAll: false,

      users: [],
      groups: []
    }
  },
  beforeCreate () {
  },
  created: function () {
    this.$store.dispatch(`${this.moduleName}/getOne`, { required: this.required })
    this.getAll()
  },
  watch: {},
  components: {},
  computed: {
    id: function () {
      return this.$store.getters[`${this.moduleName}/getId`]
    },
    data: function () {
      return this.$store.getters[`${this.moduleName}/getOne`]
    },
    errMain: function () {
      return this.$store.getters[`${this.moduleName}/getErrMain`]
    },
    errors: function () {
      return this.$store.getters[`${this.moduleName}/getErrors`]
    },
    role: function () {
      return localStorage.getItem('role')
    },

    imgSrc: function () {
      return httpService.server_api_url + this.$store.getters[`${this.moduleName}/getImgSrc`]
    },

    usersCom: function () {
      return this.users
    },
    groupsCom: function () {
      return this.groups
    }
  },
  methods: {
    async getAll () {
      try {
        let users = await httpService.get(api.users[this.role].getAll, { limit: -1 })
        let groups = await httpService.get(api.groups[this.role].getAll, { limit: -1 })
        this.users = users.data.data
        this.groups = groups.data.data
      } catch (err) {
        console.log(err)
      }
      ;
    },
    setImage (image) {
      this.image = image
      this.resetError('image')
    },
    save () {
      console.log(this.$refs.users.value)
      // let data = {};
      // data.id = this.id;
      // data.kontrollerIdMysql = this.$store.getters['kontrollers/getFinded'];
      // this.$store.dispatch(`${this.moduleName}/update`, {data: data, required: this.required});
    },
    remove () {
      // this.$store.dispatch(`${this.moduleName}/delete`);
    },
    toAll () {
      this.$store.dispatch(`${this.moduleName}/toAll`)
    },
    resetError (param) {
      this.$store.commit(`${this.moduleName}/setErrors`, { param: param, value: null })
    },
    close () {
    }
  }
}
</script>

<style scoped lang="scss">

.eventUsersComp {
  width: 350px;
  margin: 32px auto 32px auto;
}

.div_btns {
  display: grid;
  grid-template-rows: 1fr;
  grid-template-columns: 1fr 1fr;
  margin-bottom: 32px;
  margin-top: 32px;
}

.div_check {
  display: grid;
  grid-template-rows: 1fr;
  grid-template-columns: 60px 1fr;
  margin-bottom: 20px;
}

.div_check input {
  margin: auto 10px auto auto;
}

.div_check label {
  margin: auto;
}

.div_filter {
  display: grid;
  grid-template-rows: 1fr 1fr;
  grid-template-columns: 1fr;
  margin-bottom: 25px;
}

.label_filter {
  text-align: left;
}

@media screen and (max-width: 1140px) {
}

@media screen and (max-width: 960px) {
}

@media screen and (max-width: 720px) {
}

@media screen and (max-width: 540px) {
}

@media screen and (max-width: 480px) {
  .promocodeCrudComp {
    width: calc(100% - 32px);
  }
}

@media screen and (max-width: 320px) {
}

</style>
